module.exports = __webpack_public_path__ + "img/bg-07.cec51669.jpg";